import React, { useState } from 'react';

const FiltriAvanzati = ({ defaultOpen = true, hidden, mapFilters, fieldsToAvoid, onRemoveFilter, children }) => {

  const [accordionOpen, setAccordionOpen] = useState(defaultOpen);

  const accordionClick = () => {
    setAccordionOpen(!accordionOpen);
  };

  return (
    <section className='rtds-grid rtds-gap-6 lg:rtds-gap-8' hidden={hidden}>
      <div className='rtds-accordion rtds-p-0 rtds-accordion--widget'>
        <h2 className='rtds-accordion__title rtds-flex rtds-font-bold rtds-p-2 rtds-text-base rtds-background-03'>
          <button
            type='button'
            aria-expanded={accordionOpen}
            className='rtds-accordion__trigger rtds-group rtds-flex rtds-items-center rtds-flex-1 rtds-transition-all'
            aria-controls='accordionSearch-1'
            id='accordionSearch1id'
            onClick={accordionClick}
          >
            <span className='rtds-accordion__trigger-label'>
              Ricerca avanzata
            </span>
            <span className='rtds-accordion__icon rtds-flex rtds-p-2 rtds-ml-auto rtds-h-auto rtds-transition-all'>
              <svg
                className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 rtds-transition-all is-expand-arrow group-aria-expanded:rtds-rotate-180'
                aria-hidden='true'
                focusable='false'
                role='img'
              >
                <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--chevron-up`} />
              </svg>
            </span>
          </button>
        </h2>
        <div hidden={!accordionOpen}
          id='accordionSearch-1'
          role='region'
          aria-labelledby='accordionSearch1id'
          className='rtds-accordion__pane rtds-transition-all rtds-px-2'
        >
          <div className='rtds-grid rtds-gap-6'>
            {
              children
            }
          </div>
        </div>
      </div>

      <ul
        className='rtds-flex rtds-flex-wrap rtds-gap-2'
        aria-label='Filtri attivi'
      >
        {
          mapFilters && Array.from(new Map(mapFilters).entries()).filter(([key, value]) => !fieldsToAvoid || !fieldsToAvoid.includes(key)).map(([key, value]) => (
            <li key={key}>
              <span className='rtds-chip has-button-close rtds-chip--filter'>
                {key}: {value}
                <button
                  className='rtds-chip__close rtds-w-5 rtds-h-5'
                  type='button'
                  onClick={() => onRemoveFilter(key)}
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-5 rtds-h-5'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#mini--x-mark`} />
                  </svg>
                  <span className='rtds-sr-only'>Rimuovi filtro</span>
                </button>
              </span>
            </li>
          ))
        }
      </ul>
    </section>
  );
};

export default FiltriAvanzati;
